import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
    stockList: [],
    stockTrendingList: [],
    stocks: {},
    stockQuote: {},
    isDisplayChartModal: false,
    stockShareholder: [],
    chartData: null,
    stockFundQuote: [],
    stockCurrentPeriod: '1Y',
    stockCurrentUnitType: 'price',
    stockNav: [],
    stockNav1D: [],
    stockPeriod: {},
    stockTimestamp1D: {
        from: "",
        to: "",
    },
    stockFilter: [],
    stockCategories: [],
    stockFollowing: []
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
